// extracted by mini-css-extract-plugin
export var cardLayout = "_91-1";
export var paginationContainer = "_91-0";